import React from 'react';
import { AlarmClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  dark?: boolean;
  label?: string;
};
export function Countdown({
  dark = false,
  label = 'This special offer ends in:'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    unit: 'Hours'
  }, {
    value: minutes,
    unit: 'Minutes'
  }, {
    value: seconds,
    unit: 'Seconds'
  }];
  return <div className="mx-auto mt-6 w-full max-w-xl" role="timer" aria-live="off" data-id="element-86" data-mp="3h0z6t7yba12v">
      <p className={`flex items-center justify-center gap-2 text-center text-sm font-bold uppercase tracking-wide ${dark ? 'text-cta' : 'text-red-600'}`} data-id="element-87" data-mp="3gyw901qx33nl">
        <AlarmClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-88" data-mp="374vsz4u3ke03" />
        {label}
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-89" data-mp="10d4rpuzw4klu">
        {units.map((u, i) => <React.Fragment key={u.unit} data-id="element-90" data-mp="15an3dt5aldxj" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-91" data-mp="y0ww3psrg4ml">
              <span className={`flex h-16 w-[4.5rem] items-center justify-center rounded-xl text-3xl font-extrabold tabular-nums sm:h-20 sm:w-24 sm:text-4xl ${dark ? 'bg-white text-brand-950' : 'bg-brand-950 text-white'}`} data-id="element-92" data-mp="xzc0rxymghno">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? 'text-brand-200' : 'text-brand-900/60'}`} data-id="element-93" data-mp="f22e87y02o27">
                {u.unit}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-3 text-3xl font-extrabold sm:pt-5 ${dark ? 'text-white' : 'text-brand-950'}`} aria-hidden="true" data-id="element-94" data-mp="k0vta4sxqn4h">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}